import { SERVICES } from "../lib/constants";

const ITEMS = [...SERVICES.map((s) => s.title), "Free No-Obligation Quotes", "All Types of Building Work"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="services-marquee" className="overflow-hidden border-y border-brand-green/10 bg-brand-light py-4" aria-hidden="true">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center whitespace-nowrap font-heading text-sm font-bold uppercase tracking-[0.22em] text-brand-green/70">
                <span className="px-6">{item}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-brand-red/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
